<script>
  export let active = true;
  export let onClose = null;
</script>

<div class="modal modal-content-margin-mobile" class:is-active={active}>
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head has-text-centered">
      <p class="modal-card-title">
        <slot name="header"></slot>
      </p>
      <button class="delete" class:is-hidden={onClose == null} aria-label="close" on:click={onClose}></button>
    </header>
    <section class="modal-card-body has-text-centered">
        <slot name="content"></slot>
    </section>
    <footer class="modal-card-foot is-inline-block has-text-centered">
      <slot name="footer"></slot>
    </footer>
  </div>
</div>